import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAvatar,{class:_vm.classes,attrs:{"color":_vm.color,"size":_vm.size,"left":_vm.left}},[(_vm.icon)?_c(VIcon,{staticClass:"user-avatar__icon",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]):_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.initials))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }